// extracted by mini-css-extract-plugin
export default {"message":"minAmountMessage-module__message--qy7pO"};